export default __webpack_public_path__ + "static/media/p32.e35f0945.jpg";